import { Injectable } from '@angular/core';

import { I18nService } from '@recruitee/i18n';

import { Placeholder, PlaceholderData, PlaceholderId } from './placeholder';

export interface PlaceholderCollection {
  Basic: PlaceholderId[];
  Extended: PlaceholderId[];
  ExtendedUpdated: PlaceholderId[];
}

export type PlaceholdersData = Partial<Record<PlaceholderId, PlaceholderData>>;

// TODO
//  when removing defaultJobFields feature flag:
//  ExtendedUpdated should become new Extended
//  PlaceholderId.Recruiter (old) should be removed

@Injectable({
  providedIn: 'root',
})
export class PlaceholderService {
  public static readonly Collection: PlaceholderCollection = {
    Basic: [
      PlaceholderId.FirstName,
      PlaceholderId.LastName,
      PlaceholderId.Candidate,
      PlaceholderId.JobOffer,
      PlaceholderId.Company,
    ],
    Extended: [
      PlaceholderId.FirstName,
      PlaceholderId.LastName,
      PlaceholderId.Candidate,
      PlaceholderId.Recruiter,
      PlaceholderId.JobOffer,
      PlaceholderId.Company,
    ],
    ExtendedUpdated: [
      PlaceholderId.FirstName,
      PlaceholderId.LastName,
      PlaceholderId.Candidate,
      PlaceholderId.EmailSender,
      PlaceholderId.JobOffer,
      PlaceholderId.Company,
    ],
  };
  private descriptions: { [key: string]: string } = {
    [PlaceholderId.FirstName]: this.i18n.translate('app.email_templates.first_name'),
    [PlaceholderId.LastName]: this.i18n.translate('app.email_templates.last_name'),
    [PlaceholderId.Candidate]: this.i18n.translate('app.email_templates.candidate'),
    [PlaceholderId.Company]: this.i18n.translate('app.email_templates.company'),
    [PlaceholderId.Recruiter]: this.i18n.translate('app.email_templates.recruiter'),
    [PlaceholderId.EmailSender]: this.i18n.translate('app.email_templates.email_sender'),
    [PlaceholderId.RecruiterPerJob]: this.i18n.translate('app.email_templates.recruiter_per_job'),
    [PlaceholderId.HiringManager]: this.i18n.translate('app.email_templates.hiring_manager'),
    [PlaceholderId.JobOffer]: this.i18n.translate('app.email_templates.job_offer'),
    [PlaceholderId.Department]: this.i18n.translate('app.email_templates.department'),
    [PlaceholderId.EventTitle]: this.i18n.translate('app.email_templates.event_title'),
  };

  constructor(private i18n: I18nService) {}

  public createCollection(
    collectionName: keyof PlaceholderCollection,
    data: PlaceholdersData = {},
  ): Placeholder[] {
    return PlaceholderService.Collection[collectionName].map(
      id =>
        new Placeholder(id, {
          value: null,
          description: this.descriptions[id],
          status: null,
          ...(data[id] || {}),
        }),
    );
  }

  public createCustomCollection(
    placeholderIds: PlaceholderId[],
    data: PlaceholdersData = {},
  ): Placeholder[] {
    return (placeholderIds || []).map(
      id =>
        new Placeholder(id, {
          value: id,
          description: this.descriptions[id],
          status: null,
          ...(data[id] || {}),
        }),
    );
  }
}
